import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "container"]

  connect() {
    this.updateFields()
  }

  toggle() {
    this.updateFields()
  }

  updateFields() {
    const disabled = !this.checkboxTarget.checked

    this.containerTarget
      .querySelectorAll("input, select, textarea")
      .forEach((field) => {
        field.disabled = disabled
      })
  }
}
